<template>
    <header-app :class="{'header-transparent': activeHeaderTransparent}" id="header-app">
        <slot></slot>
    </header-app>
</template>

<script>
import { CHeader } from '../Styles/Header/styled'

export default {
    name: 'HeaderApp',
    props: {
        active_header_above_banner: {
            default: false
        },
        route_home: {
            requred: true
        }
    },
    components: {
        'header-app': CHeader
    },
    computed: {
        activeHeaderTransparent() {
            return this.route_home + '/' == window.location.href && JSON.parse(this.active_header_above_banner)
        }
    }
}
</script>